import { useAuth0 } from "@auth0/auth0-react"
import { Box, List, useMediaQuery } from "@mui/material"
import { DoubleCloudBox } from "./DoubleCloudBox"
import { Legalese } from "./Legalese"
import { UnauthedFormComponent } from "./UnauthedFormComponent"
import { useAppTheme } from "../../logic/useAppTheme"

export function UnauthedComponent({ drawerHeight, onSubmit, loading, pinIsCorrect, text, text2 }: {
  drawerHeight: number
  onSubmit: (pin: string) => void
  loading: boolean
  pinIsCorrect: boolean
  text: string
  text2: string
}) {

  const theme = useAppTheme() 
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const notShowingSidebar = isSmall
  const { isAuthenticated } = useAuth0();
  return (
    <Box sx={{
      maxWidth: '450px', ml: 'auto', mr: 'auto',
      mt: { xs: 0, sm: `${drawerHeight}px` },
    }}>
      <Box sx={{
        display: 'flex', pr: '20px', pl: '20px', pt: 3,
        justifyContent: 'space-between',
      }}>
        <Box sx={{
          fontSize: { xs: '46px', sm: '50px' },
          lineHeight: '54px',
          fontWeight: 300,
          minWidth: 220,
          pt: { xs: '26px', sm: '44px' },
          pl: 1,
          mb: 2,
          mr: '10px',
          letterSpacing: '-0.5px',
        }}>
          <span dangerouslySetInnerHTML={{ __html: text2 }} />
        </Box>
        <DoubleCloudBox></DoubleCloudBox>
      </Box>
      <List sx={{
        width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', mt: 3,
      }}>
        <UnauthedFormComponent onSubmit={onSubmit} loading={loading} pinIsCorrect={pinIsCorrect} text={text}/>
        {/* <Help /> */}

        {(notShowingSidebar || !isAuthenticated) ?
          <Box sx={{ pt: 1 }}>
            <Legalese></Legalese>
          </Box>
          : ''
        }
      </List>
    </Box>
  )
}
